// Superscript notation for powers can be achieved
// by capturing the part of the expression after `^`
// and displaying it inside the HTML <sup> element.
// We match 3 possible situations:
const digitOnly = '\\^([\\d]+)'; // e.g. `3^2`
const bracketsClosed = '\\^(\\([^(]+\\))'; // e.g. `3^(2 + 2)`
const bracketsOpen = '\\^(\\([^(]+)'; // e.g. `3^(2 +`

const superscriptRegex = new RegExp([digitOnly, bracketsClosed, bracketsOpen].join('|'), 'g');

const superscriptReplacer = (match, pow, closed, open) => `<sup>${pow || closed || open || match}</sup>`;

/**
 * Turns a mathematical expression into pretty HTML
 */
export default (expression) => expression
  .replace('E', 'ᴇ') // prettier exponent sign
  .replace(superscriptRegex, superscriptReplacer);
